(function () {
  /**
   * @ngdoc module
   * @name akitabox.mobile.directives.sticky
   */
  angular
    .module("akitabox.mobile.directives.sticky", ["akitabox.core"])
    .directive("abmSticky", AbmStickyDirective);

  /**
   * @ngdoc directive
   * @module akitabox.mobile.directives.sticky
   * @name AbmStickyDirective
   *
   * @description
   * `abm-sticky` is an attribute directive that allows an element to stick to the top of it's container
   *
   * @usage
   * <hljs lang="html">
   *
   * <div abm-sticky abm-append-to="app"><div>
   *
   * </hljs>
   *
   * **Note**: If used within a md-tab-content, ng-show should be used to hide the element when the tab is not active
   */
  /** @ngInject */
  function AbmStickyDirective($timeout) {
    return {
      restrict: "A",
      link: postLink,
    };

    function postLink($scope, $element, attrs) {
      $timeout(function () {
        var $content = getContent();
        var $container = $content.parent();
        var elementHeight = $element.prop("offsetHeight");
        // Move element
        $element = $element.detach();
        $element.css({
          position: "absolute",
          top: "0px",
          zIndex: 0,
        });
        $container.append($element[0]);
        // Offset scrolled content
        $content.css("margin-top", elementHeight + "px");
      });

      /**
       * Get the element that will scroll under the stickied element
       *
       * @return {Object}     Angular element
       */
      function getContent() {
        var $content = $element.parent();
        if (attrs.abmSticky === "embedded") $content = $content.parent();
        return angular.element($content);
      }
    }
  }
})();
